// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';
const ROOTS_STORE = '/store';
const ROOTS_ANALYTICS = '/dashboard';
const ROOTS_CUSTOMER_STORE = '/customer';
const ROOTS_PRODUCTS_SERVICES = '/product-services';
const ROOTS_PRODUCTS = '/product';
const ROOTS_ADVERTISEMENT = '/advertisement';
const ROOTS_CATEGORY = '/category';
const ROOTS_USER = '/user';
const ROOTS_B2B = '/b2b';
const ROOTS_REPORT = '/report';
const ROOTS_OFFER_REPORT = '/offerreport';
const ROOTS_EVENT_REPORT = '/eventreport';
const ROOTS_VEHICLES = '/vehicle';
const ROOTS_NEWVEHICLES = '/newvehicle';
const ROOTS_RATING_AND_REVIEWS = '/ratingAndReviews';
const ROOTS_EVENTS = '/event';
const ROOTS_OFFERS = '/offer';
const ROOTS_BUSINESS = '/business';
const ROOTS_SCHOOL = '/school-auto';
const ROOTS_FEATURE = '/plusFeature';
const ROOTS_CUSTOMER_ANALYTIC = '/analytic';
const ROOTS_PRIVILEDGED = '/priviledge';
const ROOTS_SPEMPLOYEE = '/spEmployee';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  forgotPassword: path(ROOTS_AUTH, '/forgot-password'),
  verify: path(ROOTS_AUTH, '/verify'),
  updatePasword: path(ROOTS_AUTH, '/update-password'),
  sellerRegisteration: path(ROOTS_AUTH, '/seller-registration')
};

export const PATH_STORE = {
  root: ROOTS_STORE,
  create: path(ROOTS_STORE, '/create'),
  edit: path(ROOTS_STORE, '/edit')
};
export const PATH_CATEGORY = {
  root: ROOTS_CATEGORY,
  create: path(ROOTS_CATEGORY, '/create'),
  edit: path(ROOTS_CATEGORY, '/edit'),
  list: path(ROOTS_CATEGORY, '/list')
};

export const PATH_CUSTOMER = {
  root: ROOTS_CUSTOMER_STORE,
  create: path(ROOTS_CUSTOMER_STORE, '/customer')
};

export const PATH_ANALYTICS = {
  root: ROOTS_ANALYTICS,
  create: path(ROOTS_ANALYTICS, '/dashboard')
};

export const PATH_PRODUCTS_SERVICES = {
  root: ROOTS_PRODUCTS_SERVICES,
  create: path(ROOTS_PRODUCTS_SERVICES, '/create'),
  edit: path(ROOTS_PRODUCTS_SERVICES, '/edit'),
  list: path(ROOTS_PRODUCTS_SERVICES, '/list'),
  createPrelist: path(ROOTS_PRODUCTS_SERVICES, '/create/prelist')
};

export const PATH_PRODUCTS = {
  root: ROOTS_PRODUCTS,
  create: path(ROOTS_PRODUCTS, '/create'),
  edit: path(ROOTS_PRODUCTS, '/edit'),
  list: path(ROOTS_PRODUCTS, '/list'),
  createPrelist: path(ROOTS_PRODUCTS, '/create/prelist')
};

export const PATH_ADVERTISEMENT = {
  root: ROOTS_ADVERTISEMENT,
  banners: path(ROOTS_ADVERTISEMENT, '/banner'),
  create: path(ROOTS_ADVERTISEMENT, '/banner/create')
};

export const PATH_EVENTS = {
  root: ROOTS_EVENTS,
  partnerCreate: path(ROOTS_EVENTS, '/partner/create'),
  customerCreate: path(ROOTS_EVENTS, '/customer/create'),
  list: path(ROOTS_EVENTS, '/list')
};

export const PATH_OFFERS = {
  root: ROOTS_OFFERS,
  partnerCreate: path(ROOTS_OFFERS, '/partner/create'),
  customerCreate: path(ROOTS_OFFERS, '/customer/create'),
  list: path(ROOTS_OFFERS, '/list')
};

export const PATH_B2B_PARTNERS = {
  root: ROOTS_B2B,
  create: path(ROOTS_B2B, '/create'),
  list: path(ROOTS_B2B, '/list')
};

export const PATH_REPORT = {
  root: ROOTS_REPORT
};

export const PATH_OFFER_REPORT = {
  root: ROOTS_OFFER_REPORT
};

export const PATH_EVENT_REPORT = {
  root: ROOTS_EVENT_REPORT
};

export const PATH_VEHICLES = {
  root: ROOTS_VEHICLES,
  create: path(ROOTS_VEHICLES, '/create'),
  edit: path(ROOTS_VEHICLES, '/edit')
};

export const PATH_NEW_VEHICLES = {
  root: ROOTS_NEWVEHICLES,
  create: path(ROOTS_NEWVEHICLES, '/create'),
  list: path(ROOTS_NEWVEHICLES, '/list')
};

export const PATH_RATING_AND_REVIEWS = {
  root: ROOTS_RATING_AND_REVIEWS
};

export const PATH_USER_PROFILE = {
  root: ROOTS_USER,
  create: path(ROOTS_USER, '/create')
};

export const PATH_BUSINESS = {
  root: ROOTS_BUSINESS,
  partnerCreate: path(ROOTS_BUSINESS, '/partner/create'),
  customerCreate: path(ROOTS_BUSINESS, '/customer/create'),
  // create: path(ROOTS_BUSINESS, '/create'),
  list: path(ROOTS_BUSINESS, '/list')
};

export const PATH_SCHOOL = {
  root: ROOTS_SCHOOL,
  partnerCreate: path(ROOTS_SCHOOL, '/partner/create'),
  customerCreate: path(ROOTS_SCHOOL, '/customer/create'),
  list: path(ROOTS_SCHOOL, '/list')
};

export const PATH_FEATURE = {
  root: ROOTS_FEATURE,
  create: path(ROOTS_FEATURE, '/plusFeature')
};

export const PATH_CUSTOMER_ANALYTICS = {
  root: ROOTS_CUSTOMER_ANALYTIC,
  customerList: path(ROOTS_CUSTOMER_ANALYTIC, '/customer'),
  plusFeatureList: path(ROOTS_CUSTOMER_ANALYTIC, '/advertisement&&plusFeature'),
  partnerList: path(ROOTS_CUSTOMER_ANALYTIC, '/partner')
};

export const PATH_PRIVILEDGED = {
  root: ROOTS_PRIVILEDGED
};

export const PATH_SPEMPLOYEE = {
  root: ROOTS_SPEMPLOYEE,
  create: path(ROOTS_SPEMPLOYEE, '/create'),
  list: path(ROOTS_SPEMPLOYEE, '/list')
};
